export type DisablePriceListReasonKey =
    "rule-max-capacity-exceeded"
    | "rule-required-row-insufficient-inventory"
    | "rule-required-row-limit-exceeded"
export const PRICE_LIST_REQUIRED_ROW_LIMIT_EXCEEDED:
    DisablePriceListReasonKey = "rule-required-row-limit-exceeded"
export const PRICE_LIST_REQUIRED_ROW_INSUFFICIENT_INVENTORY:
    DisablePriceListReasonKey = "rule-required-row-insufficient-inventory"
export const PRICE_LIST_MAX_CAPACITY_EXCEEDED:
    DisablePriceListReasonKey = "rule-max-capacity-exceeded"

export type DisableRowReasonKey =
    "rule-row-quantity-hits-price-list-capacity"
    | "rule-row-insufficient-inventory"
    | "rule-row-limit-exceeded"
export const ROW_EXCEEDS_PRICE_LIST_CAPACITY: DisableRowReasonKey = "rule-row-quantity-hits-price-list-capacity"
export const ROW_INSUFFICIENT_INVENTORY: DisableRowReasonKey = "rule-row-insufficient-inventory"
export const ROW_LIMIT_EXCEEDED: DisableRowReasonKey = "rule-row-limit-exceeded"



// WEBPACK FOOTER //
// ./src/state/pricing/DisableReasonKeys.ts